const layoutSettings = {
  leftSidebar: {
    theme: 'sidebar-dark-purple',
  },
  header: {
    show: true,
  },
  searchBox: {
    open: false,
  },
  secondarySidebar: { show: false },
};

export default layoutSettings;
